<template>
    <span>
        <font-awesome-icon :icon="['fa', 'table']" @click="GetTableColumnsAndShowModal" class="pointer"></font-awesome-icon>
        <b-modal class="modal" size="huge" ref="columnEditor" :title='"Editing Columns for " + TableLabel' hide-footer>
            <b-container>
                <b-form @submit="SaveMyUserSetting">
                    <b-row class="justify-content-md-center">
                        <fieldset class="box" style="margin-right:5%; margin-bottom:2%;">
                            <legend style="border: 1px black solid;margin-left: 1em; padding: 0.2em 0.8em ">Visible Columns</legend>
                            <b-col style="height: 50vh; overflow-y:auto; margin-bottom:5%">
                                <draggable style="height: 100%;" class="list-group" tag="ul" v-model="VisibleColumns" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
                                    <transition-group style="height: 100%;" type="transition" :name="'flip-list'">
                                        <li class="list-group-item" v-for="element in VisibleColumns" :key="element.order" :style="[element.IsEditable ? null : {'background-color': 'lightgray'}]">
                                            <font-awesome-icon :icon="['fa', 'ellipsis-v']" @click="GetTableColumnsAndShowModal"></font-awesome-icon>
                                            {{element.Label}}
                                        </li>
                                    </transition-group>
                                </draggable>
                            </b-col>
                        </fieldset>
                        <fieldset class="box" style="margin-bottom:2%;">
                            <legend style="border: 1px black solid;margin-left: 1em; padding: 0.2em 0.8em ">Hidden Columns</legend>
                            <b-col style="height: 50vh; overflow-y:auto; margin-bottom:5%">
                                <draggable style="height: 100%;" tag="div" v-model="HiddenColumns" v-bind="dragOptions" :move="onMove">
                                    <transition-group style="height: 100%;" name="no" class="list-group" tag="ul">
                                        <li class="list-group-item" v-for="element in HiddenColumns" :key="element.order">
                                            <font-awesome-icon :icon="['fa', 'ellipsis-v']" @click="GetTableColumnsAndShowModal"></font-awesome-icon>
                                            {{element.Label}}
                                        </li>
                                    </transition-group>
                                </draggable>
                            </b-col>
                        </fieldset>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="$refs.columnEditor.hide()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                            <b-button size="md" variant="warning" @click="ResetSettingsToDefault" type="button" style="float:left;">
                                DEFAULT
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </span>
</template>

<script>
    import draggable from 'vuedraggable'
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faTable } from '@fortawesome/free-solid-svg-icons';
    library.add(faTable);
    import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
    library.add(faEllipsisV);
    import { EventBus } from '../../../services/event-bus.js';
    export default {
        name: "EmployeeColumnCustomizationEditor",
        created() {
        },
        props: ['TableLabel','TableSettingsName','UpdateEventMessage','ColumnsDefaultsEndpoint'],
        data: function () {
            return {
                CurrentUserSettings: [],
                VisibleColumns: [],
                HiddenColumns: [],
                editable: true,
                isDragging: false,
                delayedDragging: false
               
            };
        },
        methods: {
            GetTableColumns() {
                this.$MasterAPI.ExecuteRequest("GET", this.ColumnsDefaultsEndpoint, {SettingName: this.TableSettingsName}, this.GetTableColumnsSuccess, () => { }, false);                
            },
            GetTableColumnsSuccess(response) {
                let vm = this;                
                vm.VisibleColumns = [];
                vm.HiddenColumns = [];
                response.data.data.forEach(function (col) {
                    if (col.Visible == true) {
                        if (col.IsEditable == false) {

                        }
                        vm.VisibleColumns[col.order] = col;
                    }
                    else {
                        vm.HiddenColumns.push(col);
                    }
                });
            },
            SaveMyUserSetting(e) {
                e.preventDefault();
                let saveMySettings = this.VisibleColumns.map(a => a.name).join();
                this.$MasterAPI.ExecuteRequest("POST", "Core/UserSettings/SaveMyUserSetting", { SettingName: this.TableSettingsName, SettingValue: saveMySettings}, this.SaveMyUserSettingSuccess, () => { }, true);

            },
            SaveMyUserSettingSuccess(response) {
                EventBus.$emit(this.UpdateEventMessage);
                this.$refs.columnEditor.hide();
            },
            ResetSettingsToDefault(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Core/UserSettings/ResetSettingsToDefault", { SettingName: this.TableSettingsName}, this.ResetSettingsToDefaultSuccess, () => { }, false);
            },
            ResetSettingsToDefaultSuccess(response) {
                EventBus.$emit(this.UpdateEventMessage);
                this.$refs.columnEditor.hide();
            },
            onMove({ relatedContext, draggedContext }) {
              const relatedElement = relatedContext.element;
              const draggedElement = draggedContext.element;
              return (
                (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
              );
            },
            GetTableColumnsAndShowModal() {
                this.GetTableColumns();
                this.$refs.columnEditor.show();
                
            },
        },
        components: {
            draggable
        },
        computed: {
            dragOptions() {
              return {
                animation: 0,
                group: "description",
                disabled: !this.editable,
                ghostClass: "ghost"
              };
            },
          },
          watch: {
            isDragging(newValue) {
              if (newValue) {
                this.delayedDragging = true;
                return;
              }
              this.$nextTick(() => {
                this.delayedDragging = false;
              });
            },
              HiddenColumns: {
                  handler: function (val, oldVal) {
                      let vm = this;
                      let newArray = val.filter(function (v) {
                            return v.IsEditable == false;
                      });
                      newArray.forEach(function (i) {
                          vm.VisibleColumns[vm.VisibleColumns.length] = i;
                      });
                      if (newArray.length > 0) {
                          this.HiddenColumns = this.HiddenColumns.filter(function (v) {
                            return v.IsEditable == true;
                          });
                      }
                      
                  },
              },
          },
        mounted() {
        }
    }
</script>

<style scoped>
    .flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
.box{
    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
    border: 1px black solid;
}
/deep/ .modal .modal-huge {
  min-width: 75vw !important;
  min-height: 75vh !important;
}
</style>